module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "toptype": 6
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between align-start ",
    staticStyle: {
      "background": "#eef1fa",
      "padding": "30px 0",
      "min-height": "600px"
    }
  }, [(_vm.detail) ? _c('div', {
    staticClass: "marginauto animated fadeInUp",
    staticStyle: {
      "width": "1145px"
    }
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "width": "945px",
      "padding": "20px 100px 50px 100px",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "sd_title"
  }, [_c('p', {
    staticClass: "biaoti1"
  }, [_vm._v(_vm._s(_vm.detail.name))]), _vm._v(" "), _c('p', {
    staticClass: "bt_mes"
  }, [_vm._v("\n                        信息来源："), _c('span', [_vm._v(_vm._s(_vm.detail.source))]), _vm._v(" 发布日期："), _c('span', [_vm._v(_vm._s(_vm.detail.release_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "sd_content padding-top"
  }, [(_vm.detail.content) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.detail.content) ? _c('el-empty', {
    attrs: {
      "description": "暂无详细介绍"
    }
  }) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('callview', {
    attrs: {
      "text": _vm.config.rongzi_detail
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b233d8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/financedetail.vue
// module id = 382
// module chunks = 1